import {
  PropsWithChildren,
  type FC
} from 'react';
import {
  Stack, Typography, styled
} from '@mui/joy';

const KeyValueText = styled(Typography)(({ theme }) => ({
  fontSize: 14,
  fontWeight: 400,
  lineHeight: '20px',
  fontStyle: 'normal',
  color: theme.palette.common.white
}));

interface KeyValueInfoSectionProps extends FC<PropsWithChildren> {
  Key: FC<PropsWithChildren>;
  Value: FC<PropsWithChildren>;
};

export const KeyValueInfoSection: KeyValueInfoSectionProps = ({ children }) => (
  <Stack
    width='100%'
    direction='row'
    alignItems='center'
    justifyContent='space-between'
    sx={({ palette }) => ({
      paddingBlock: 1,
      borderBottomWidth: 1,
      borderBottomStyle: 'solid',
      borderBottomColor: palette.common[925],
    })}>
    {children}
  </Stack>
);

KeyValueInfoSection.Key = ({ children }) => (
  <KeyValueText>
    {children}
  </KeyValueText>
);

KeyValueInfoSection.Value = ({ children }) => (
  <KeyValueText>
    {children}
  </KeyValueText>
);